export const navMenus = {
  market: [
    { label: 'States', path: '/market/states' },
    { label: 'Cities', path: '/market/cities' },
  ],

  realestate: [
    { label: 'Median house price', path: '/real-state-indicators' },
    { label: 'Median weekly rent',  path: '/real-state-indicators' },
    { label: 'Dwelling units commenced', path: '/real-state-indicators' },
    { label: 'Total dwelling approvals units',path: '/real-state-indicators' },
    { label: 'Vacancies and vacancy rates', path: '/real-state-indicators' },
    { label: 'Rental yield', path: '/real-state-indicators' },
  ],

  economic: [
    { label: 'Average of GRP% change', path: '/economic-indicators' },
    { label: 'Average of unemployment rate', path: '/economic-indicators' },
    { label: 'Avg change estimated resident population', path: '/economic-indicators' },
    { label: 'Australian map by capital cities', path: '/economic-indicators' },
  ],

  topsuburbs: [
    { label: 'Real estate market insight suburbs', path: '/top-suburbs/insight' },
    { label: 'Suburbs indicators', path: '/top-suburbs/indicators' },
  ],
};
